/** @jsx builderX.jsx */

import {builderX, Sprite, Text} from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite position={[0, 0]} name='cash'>
        <Text
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 55,
                fontStyle: 'normal',
                fill: '#FFD200',
                align: 'left',
                fontWeight: 'bold'
            }}
            maxWidth={600}
            name='fieldText'
            localeTextID=''
            text='$20000.00'
        />
    </Sprite>
);
